import { cacheKeys } from '@/enum/cacheKeys.ts'

interface AuthDialogOptions {
  showCloseButton?: boolean;
  maxWidth?: number | string;
  title?: string;
}

const model = ref(false)
const showCloseButton = ref(true)
const maxWidth = ref<string | number>('576')
const title = ref<string | null>(null)

export const useAuthDialog = () => {
  const cacheStore = useCacheStore()

  const accessLimited = (): boolean => {
    return cacheStore.has(cacheKeys.messageLimitAuthDialog)
  }

  const limitAndShow = (options: AuthDialogOptions = {}) => {
    cacheStore.setWithTTL(cacheKeys.messageLimitAuthDialog, true, 24 * 60 * 60)
    show(options)
  }

  const show = (options: AuthDialogOptions = {}) => {
    model.value = true
    showCloseButton.value = options.showCloseButton || showCloseButton.value
    maxWidth.value = options.maxWidth || maxWidth.value
    title.value = options.title || null

    useTrackStore().track('signup_presented', { 'type': 'popup' })
  }

  const hide = () => {
    model.value = false
  }

  const reset = () => {
    cacheStore.remove(cacheKeys.messageLimitAuthDialog)
  }

  return {
    model,
    accessLimited,
    show,
    limitAndShow,
    hide,
    reset,
    showCloseButton,
    maxWidth,
    title,
  }
}
